import { React } from "react";
import styled from "styled-components";
import { useRoutePlanner } from "../../context/RoutePlannerContext";

const HintWrapper = styled.div`
  position: fixed;
  bottom: 56px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  max-width: min(92vw, 560px);
  width: max-content;
`

const Card = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border-radius: 14px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.18);
  animation: hint-in 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  @keyframes hint-in {
    from {
      opacity: 0;
      transform: translateY(8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 576px) {
    gap: 10px;
    padding: 12px 12px;
  }
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
  color: #4d4d4d;
  line-height: 1.4;
  min-width: 0;

  strong {
    font-size: 14px;
    color: #0d0c1d;
    font-weight: 700;
  }
`

const PlanRoute = styled.button`
  flex-shrink: 0;
  border: none;
  border-radius: 8px;
  padding: 8px 14px;
  background: #fc3a34;
  color: #fff;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #d92a24;
  }
`

const Close = styled.button`
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: #8a8a8a;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;

  &:hover {
    color: #0d0c1d;
  }
`

const MapHint = ({ visible, onDismiss }) => {
  const { open } = useRoutePlanner();

  const planRoute = () => {
    open();
  };

  if (!visible) {
    return null;
  }

  return (
    <HintWrapper>
      <Card>
        <Body>
          <strong>Live Manchester Metrolink map</strong>
          <span>Drag to pan · scroll or pinch to zoom · tap a station for live travel alerts</span>
        </Body>
        <PlanRoute
          type="button"
          onClick={planRoute}
          data-umami-event="Route planner opened"
        >
          Plan a route
        </PlanRoute>
        <Close
          type="button"
          onClick={onDismiss}
          aria-label="Dismiss"
          data-umami-event="Map hint dismissed"
        >
          ×
        </Close>
      </Card>
    </HintWrapper>
  );
};

export default MapHint;
